module.exports = __webpack_public_path__ + "img/calendar2_p.56367978.svg";